// export const backendServerInvestor = 'http://api.test.thundersdata.com/one-du-dev';
// export const backendServer = 'http://api.test.thundersdata.com/one-du-dev/web';
// export const userServer = 'http://api.test.thundersdata.com';
// export const backendServerInvestor = 'http://192.168.1.37:8080';
// export const backendServer = 'http://192.168.1.37:8080/web';

// const backendServerInvestor = 'http://192.168.1.128:8080';
// const backendServer = 'http://s2423360f4.wicp.vip';
// const backendServer = 'http://192.168.1.169:8080'; //晓鹏老师本地

export const backendServerInvestor = 'https://api.thundersdata.com/one-du-shop';
export const backendServer = 'https://api.thundersdata.com/one-du-shop/web';
export const userServer = 'https://api.thundersdata.com';


/**
 * 项目进度
 */
export const PROJECT_STATUS = {
  0: '未成团',
  1: '已成团',
  // 2: '项目已成团，原材料购买中',
  2: '原材料购买中',
  // 3: '原材料已购买，电站建设中',
  3: '电站建设中',
  // 4: '电站建设完毕，并网备案中',
  4: '并网备案中',
  5: '项目审核中',
  6: '审核完成',
  10: '已发布项目',
  20: '审核未通过'
};

export const ROLE_CODE = {
  noRole: 0,
  projectSide: 1,
  investor: 2
};

export const PAGE_SIZE = 10;

// 用户状态
// const USER_STATUS = {
//   0: '未购买',
//   1: '已申请',
//   2: '已付款',
//   3: '已驳回',
//   4: '申购成功',
//   5: '取消申购',
//   6: '超时,自动取消'
// };

export const USER_STATUS = {
  1: '等待买家付款',
  2: '支付成功',
  3: '交易结束，不可退款',
  4: '交易超时关闭，不可退款',
  5: '买房约人打款'
};

// 逆变器类型
export const inverterType = [
  {
    key: 'grwt',
    value: '古瑞瓦特'
  },
  {
    key: 'jl',
    value: '锦浪'
  },
  {
    key: 'at',
    value: '奥泰'
  },
  {
    key: 'goodway',
    value: '固德威'
  }
];
// 锦浪账号类型
export const jlAccountType = [
  {
    key: 0,
    value: '普通用户'
  },
  {
    key: 1,
    value: '代理商大账号'
  }
];
export const fileUrl = `${backendServerInvestor}/oss/public/upload`;
export const projectFileUploadUrl = `${backendServer}/project/upload`;

export const INVERTER_BRAND = {
  growatt: '古瑞瓦特',
  at: '奥泰',
  goodway: '固德威'
};

export const COLLECTOR_BRAND = {
  growatt: '古瑞瓦特',
  at: '奥泰',
  goodway: '固德威'
};

export const COMPONENT_BRAND = {
  dahaipv: '大海光伏'
};

export const CLIENT_ID = 'test';

/**交易状态 */
export const TRADE_STATUS = {
  WAIT_BUYER_PAY: 1, //交易创建，等待买家付款
  TRADE_SUCCESS: 2, //支付成功
  TRADE_FINISHED: 3, //交易结束，不可退款,
  TRADE_CLOSED: 4, //未付款交易超时关闭，或支付完成后全额退款
  BUYER_ENSURE: 5, //买方确认打款
  BUYER_CANCEL: 6, //买家取消订单
  SELLER_CANCEL: 7, //卖家取消订单
};

/**出售状态 */
export const SELL_STATE = {
  SELL_DOING: 0,
  SELL_DONE: 2,
  SELL_REVOKE: 1
};


export const VERSION='3.0.8';

// 短信发送状态
export const MESSAGE_SEND = {
  SEND_DONE: 3,
  SEND_NO: 2
}

export const PROJECT_TYPE = {
  COMMON: 0,
  VIRTUAL: 1
};




// WEBPACK FOOTER //
// ./src/variable.js